import {IAuthentication} from "../../models/security/authentication.interface";

export interface IAuthenticationState {
  data: IAuthentication;
}
export const initialAuthenticationState: IAuthenticationState = {
  data: {
    accessToken: '',
    isAuthenticated: false,
    oidcAccessToken: '',
    oidcProviderType: 'unknown',
    isGoogleSignedIn: false,
    authenticationInProgress: false,
    login: '',
    password: '',
    workflowToken: ''
  }

};


